import { observer } from 'mobx-react-lite'
import React from 'react'
import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type IDiscoverBoxData } from 'pages/discover/lib/types'
import { type DiscoverStore } from 'pages/discover'
import { BoxListCardStatus } from 'pages/discover/ui/BoxListCardStatus/BoxListCardStatus'
import styles from './styles.module.scss'

type IBoxListCardProps = {
  box: IDiscoverBoxData
  store: DiscoverStore
}

export const BoxListCard = observer(({ box, store }: IBoxListCardProps) => {
  const { handleCardClick } = store
  const isDisabled = !box.redirectTo
  const cardAriaLabel = getAriaLabel('IntegrationCard', box.id)

  return (
    <div
      className={classNames(styles.card, { [styles.cardDisabled]: isDisabled })}
      aria-label={cardAriaLabel}
      onClick={() => handleCardClick(box)}
    >
      <div className={styles.cardHeader} aria-label={getAriaLabel(cardAriaLabel, 'header')}>
        <Icon icon={box.icon} fontSize={28} className={styles.icon} />
        <BoxListCardStatus box={box} />
      </div>
      <div className={styles.data} aria-label={getAriaLabel(cardAriaLabel, 'info')}>
        <Typography
          className={styles.cardTitle}
          variant='body-md-medium'
          ariaLabel={'Integration_name'}
        >
          {box.title}
        </Typography>
        <Typography
          variant='body-md-regular'
          ariaLabel={'Integration_subheadline'}
          className={styles.subheadline}
        >
          {box.description}
        </Typography>
      </div>
    </div>
  )
})
